export const getShowingTime = (
  startTime: string | Date,
  endTime: string | Date,
  delimiter: 'dot' | 'comma' = 'comma',
): string => {
  // Extracting the day and month for the date part
  const datePart = new Date(startTime).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
  });

  // Extracting the hours and minutes for the start time
  const startTimePart = new Date(startTime).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });

  // Extracting the hours and minutes for the end time
  const endTimePart = new Date(endTime).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
  });

  if (delimiter === 'dot') {
    return `${datePart} · ${startTimePart} - ${endTimePart}`;
  }

  return `${datePart}, ${startTimePart} - ${endTimePart}`;
};
